import { Box, Image as NewImage, Spacer, Text as NewText } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import React, { FC, useState } from 'react'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { styles } from './styles'

const Conversions = require('../../assets/images/conversion-filled.png')
const Experiance = require('../../assets/images/experience.png')
const ImageKeyboradBackSpace = require('../../assets/images/arrow-right-blue.png')
const SecureData = require('../../assets/images/secure-filled.png')
const conver3 = require('../../assets/images/whyjio/homep/firewall.svg')
const conver1 = require('../../assets/images/whyjio/homep/increment.svg')
const conver2 = require('../../assets/images/whyjio/homep/game-controls.svg')
const conver4 = require('../../assets/images/whyjio/homep/ominz.svg')
const Presence = require('../../assets/images/widen-presence-filled.png')

const whyJioData = [
  {
    id: 'increase-conversion',
    uri: Conversions,
    header: staticStrings.incCon,
    subtext: staticStrings.betterSales,
    URI: conver1,
  },
  {
    id: 'widen-presence',
    uri: Presence,
    header: staticStrings.acrossActive,
    subtext: staticStrings.reach3Million,
    URI: conver2,
  },
  {
    id: 'mitigate-risk',
    uri: SecureData,
    header: staticStrings.mitigateRisk,
    subtext: staticStrings.preventFraud,
    URI: conver3,
  },
  {
    id: 'simplified-experience',
    uri: Experiance,
    header: staticStrings.omniChannel,
    subtext: staticStrings.uniqueExp,
    URI: conver4,
  },
]

const WhyJioBox = (
  item: any,
  themedStyle: any,
  navigation: any,
  index: number,
  isMob: boolean,
  _isTab: boolean,
): React.ReactElement => {
  const handleNav = () => {
    navigation.navigate(item.id)
  }
  const isTopLeft = index === 0
  const isTopRight = index === 1
  const isBottomLeft = index === 2
  const isBottomRight = index === 3

  const [hovering, updateRenderItemHovering] = useState(false)
  const onItemHover = (isHovering: boolean) => {
    updateRenderItemHovering(isHovering)
  }

  return (
    <>
      <LinearGradientContainer
        colorArray={hovering && !isMob ? [colors.HOVER_BG, colors.HOVER_BG] : ['#FFF', '#FFF']}
        customStyle={themedStyle.whyJioTextContainer(isTopLeft, isBottomRight, isTopRight, isBottomLeft)}
        direction="VERTICAL">
        <>
          <Box
            onHover={onItemHover}
            ph={isMob ? 0 : _isTab ? 24 : 20}
            pv={isMob ? 12 : _isTab ? 32 : 20}
            key={item.id}
            underlayColor="TRANSPARENT"
            f={isMob || _isTab ? undefined : 1}
            onPress={handleNav}>
            <>
              <Box key={item.header} {...themedStyle.textContentOverlap}>
                <NewImage
                  source={item.URI}
                  height={isMob || _isTab ? 48 : 64}
                  width={isMob || _isTab ? 48 : 64}
                  borderRadius={23}
                />
                <Box {...themedStyle.whyjiodime}>
                  <NewText
                    fontFamily="jiotype-bold"
                    color="BLACK_21"
                    fontSize={isMob || _isTab ? 18 : 24}
                    lineHeight={isMob || _isTab ? 24 : 32}>
                    {item.header}
                  </NewText>
                </Box>
                <NewText
                  color="BLACK_21"
                  opacity={0.9}
                  fontFamily="jiotype-medium"
                  lineHeight={isMob || _isTab ? 18 : 28}
                  fontSize={isMob || _isTab ? 14 : 18}>
                  {item.subtext}
                </NewText>
              </Box>
              <Box marginTop={isMob ? 6 : 24} flexDirection="row" alignItems="center" pt={10}>
                <NewText color="BLUE_SHADE" fontFamily="jiotype-medium" fontSize={isMob ? 14 : 18}>
                  {'Know More'}
                </NewText>
                <Spacer direction={'horizontal'} size={isMob ? 4 : 8} />
                <NewImage
                  source={ImageKeyboradBackSpace}
                  height={isMob ? 16 : 24}
                  width={isMob ? 16 : 24}
                  resizeMode="contain"
                />
              </Box>
            </>
          </Box>
        </>
      </LinearGradientContainer>
      <ModBox {...themedStyle.borderLine} show={isMob && !isBottomRight} />
    </>
  )
}

const WhyJio: FC = () => {
  const navigation = useNavigation()
  const { headerSize } = useFontSize()

  const viewPortWidth = useWindowDimensions()
  const isTab = isTabletWidth(viewPortWidth)
  const isMob = isMobileWidth(viewPortWidth)
  const responsivePadding = usePadding()
  const themedStyle = styles(viewPortWidth, responsivePadding)

  const WhyJioContent = whyJioData.map((item, index) => {
    return WhyJioBox(item, themedStyle, navigation, index, isMob, isTab)
  })

  return (
    <Box nativeID="whyjio" mt={isTab ? 100 : isMob ? 120 : 200}>
      <NewText color="BLACK" fontFamily="jiotype-black" fontSize={headerSize}>
        {staticStrings.whyjio}
      </NewText>
      <Box {...themedStyle.content} {...themedStyle.whyjiofix}>
        <Box {...themedStyle.whyjiocontainer}>{WhyJioContent}</Box>
      </Box>
    </Box>
  )
}

export default WhyJio
